import { useMemo } from 'react';
import styled from 'styled-components';
import { IStaffUI } from 'types/staff';
import ServicesSection from './Services';
import StaffSection from './Staff';
import qbSignal, { IQuickBookStaffSelected } from 'QuickBooking/signal';
import { Form } from 'antd';

type StaffServicesSectionProps = {
  value?: IQuickBookStaffSelected;
  name?: any;
  staffStore: IStaffUI[];
  remove: () => void;
  disabledRemove?: boolean;
  onChange?: (value: IQuickBookStaffSelected) => void;
  handleOnChangeStaff?: (value?: IQuickBookStaffSelected, onChange?: (value: IQuickBookStaffSelected) => void) => void;
};
const StaffServicesSection = ({ value, name, staffStore, remove, disabledRemove, onChange, handleOnChangeStaff: _handleOnChangeStaff }: StaffServicesSectionProps) => {
  const staff = useMemo(() => {
    return staffStore.find(o => o.id?.toString() === value?.id?.toString()) || null;
  }, [staffStore, value?.id]);

  const handleOnChangeStaff = () => {
    _handleOnChangeStaff?.(value, onChange);
  };
  return (
    <Container>
      <StaffSection name={name} staff={staff} remove={remove} disabledRemove={disabledRemove} onChangeStaff={handleOnChangeStaff} />
      {/* `name` la chi so that cua dong trong Form.List, cung he quy chieu voi chi so ma
          validate tra ve, nen canh bao roi dung dong dang thieu dich vu. */}
      <Form.Item name={[name, 'services']} noStyle>
        <ServicesSection warning={qbSignal.serviceWarningRow.value === name} />
      </Form.Item>
    </Container>
  );
};

export default StaffServicesSection;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .button-add-more {
    display: flex;
    padding-right: 12px;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    background: #C5DDF8;
    span {
      color: #1D2129;
      text-align: center;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      text-transform: uppercase;
    }
  }
`;